import React from 'react';
import { Placement } from '@noths/polaris-client-ribbons-design-system';

import {
  RecentlyViewedWithRichRelevance,
  RecentlyViewedWithRichRelevanceProps as RichRelevanceCarouselProps,
} from '../../organisms/RecentlyViewed';
import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './RichRelevanceCarouselBlock.style';

export const RichRelevanceCarouselBlock = (props: RichRelevanceCarouselProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
    <RecentlyViewedWithRichRelevance {...props} />
  </BlockContainer>
);

export type { RichRelevanceCarouselProps };
export { Placement };
